import UJwtCreditCard from '../../core/jwt/UJwtCreditCard'

const { jwtCC } = UJwtCreditCard({})

export default jwtCC
